export default __webpack_public_path__ + "static/media/credit-card.c74af623.svg";